import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

// views
import SignIn from "@/views/sign-in.vue";
import HostedPage from "@/views/hosted-page.vue";
import HomePage from "@/views/index.vue";
import Payment from "@/views/Payment.vue";
import Preview from "@/views/preview.vue";

// middlewares
import signIn from "./middleware/sign-in";
import signedIn from "./middleware/signed-in";
// import ssoUser from './middleware/sso-user';
import middlewarePipeline from "./middlewarePipeline";
import app from "@/main";
import { routeParser } from "@/utils/helper";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
    meta: {
      login: false,
    },
  },
  {
    path: "/sign-in",
    name: "Sign in",
    component: SignIn,
    meta: {
      middleware: [signedIn],
      settings: false,
    },
  },
  {
    path: "/sign-up",
    name: "SignUp",
    component: () => import("@/views/sign-up.vue"),
    meta: {
      // middleware: [
      //   signedIn,
      // ],
      login: true,
    },
  },
  {
    path: "/guest",
    name: "VerifyGuest",
    component: () => import("../components/verifyGuest.vue"),
    meta: {
      // middleware: [
      //   signedIn,
      // ],
      settings: false,
    },
  },
  {
    path: "/verification-sent",
    name: "VerificationSent",
    component: () => import("@/views/verification-sent.vue"),
    props: true,
  },
  {
    path: "/add-bank",
    name: "AddBank",
    component: () => import("@/views/add-bank.vue"),
    meta: {
      middleware: [signIn],
      login: true,
    },
  },
  {
    path: "/email-confirm",
    name: "EmailConfirm",
    component: () => import("@/views/email-confirm.vue"),
    meta: {
      settings: false,
    },
    props: routeParser,
  },
  {
    path: "/totp/:data",
    name: "Totp",
    component: () => import("@/views/totp.vue"),
    props: true,
    meta: {
      middleware: [signedIn],
    },
  },
  {
    path: "/hostedPage/:id",
    name: "HostedPage",
    component: HostedPage,
    meta: {
      middleware: [signIn],
      login: false,
    },

    props: true,
  },
  {
    path: "/payment",
    name: "Payment",
    component: Payment,
    meta: {
      middleware: [signIn],
      settings: true,
    },
    props: true,
  },
  {
    path: "/unauth-payment",
    name: "Unauth payment",
    component: () => import("@/views/unauth-payment.vue"),
    meta: {
      middleware: [signedIn],
      login: false,
    },
  },
  {
    path: "/preview",
    name: "Preview",
    component: Preview,
    meta: {
      // middleware: [
      //   signedIn,
      // ],
      login: false,
    },
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("@/views/settings.vue"),
    meta: {
      middleware: [signIn],
      login: false,
    },
  },
  {
    path: "/connections",
    name: "Connections",
    component: () => import("@/views/connections.vue"),
    meta: {
      middleware: [signIn],
      settings: true,
    },
  },
  {
    path: "/connect-result",
    name: "Connect result",
    component: () => import("@/views/connect-result.vue"),
    props: routeParser,
    meta: {
      middleware: [signIn],
      settings: true,
    },
  },
  {
    path: "/coinbase-reset",
    name: "Coinbase reset",
    component: () => import("@/views/coinbase-reset.vue"),
    props: (route) => {
      try {
        return {
          data: JSON.parse(route.query.data),
          amount: route.query.amount,
        };
      } catch (error) {
        return true;
      }
    },
    meta: {
      middleware: [signIn],
      settings: true,
    },
  },
  {
    path: "/sms-verify",
    name: "SMS Verify",
    component: () => import("@/views/sms-verify.vue"),
    props: true,
    meta: {
      middleware: [signIn],
      settings: true,
    },
  },
  {
    path: "/rocketfuel-verify/:data",
    name: "Rocketfuel Verify",
    component: () => import("@/views/rocketfuel-verify.vue"),
    props: true,
    meta: {
      middleware: [signIn],
      settings: true,
    },
  },
  {
    path: "/qr-code",
    name: "Qr code",
    component: () => import("@/views/qr-code.vue"),
    props: true,
    meta: {
      middleware: [signIn],
      settings: true,
    },
  },
  {
    path: "/result",
    name: "Result",
    component: () => import("@/views/result.vue"),
    props: true,
    meta: {
      middleware: [
        signIn,
        // signIn, ssoUser,
      ],
    },
  },
  {
    path: "/coinbase-limit",
    name: "CoinbaseLimit",
    component: () => import("@/views/coinbase-limit"),
    meta: {
      middleware: [signIn],
      settings: false,
    },
  },
  {
    path: "/forget-password",
    name: "ForgetPassword",
    component: () => import("@/views/forget-password"),
    meta: {
      middleware: [signedIn],
      login: false,
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("@/views/reset-password"),
    meta: {
      middleware: [signedIn],
      login: false,
    },
  },
  {
    path: "/welcome",
    name: "Welcome",
    component: () => import("@/views/welcome.vue"),
    meta: {},
  },
  {
    path: "/thank-you",
    name: "Thank",
    component: () => import("@/views/thank-you.vue"),
    meta: {
      // middleware: [
      //   signedIn,
      // ],
      // login: false,
    },
  },
  {
    path: "/auth-popup/:exchange",
    name: "Auth Popup",
    component: () => import("@/views/exchange-auth-popup.vue"),
    props: true,
    meta: {
      login: true,
    },
  },
  {
    path: "/link",
    name: "LinkBrowse",
    component: () => import("@/views/link-browse.vue"),
    props: true,
    meta: {
      login: false,
    },
  },
  {
    path: "/exchange/:exchange",
    name: "Exchange",
    component: () => import("@/views/exchange/connect.vue"),
    props: true,
    meta: {
      login: false,
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404.vue"),
    props: true,
    meta: {
      login: false,
    },
  },
  {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component:  () => import("@/views/404.vue"),
  },
  {
    path: "/refund-requested",
    name: "RefundRequested",
    component: () => import("@/views/refund-success.vue"),
    meta: {
      middleware: [signIn],
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // Баг! При открытии расширения код в этом блоке выполняется 2 раза
  const access = app.prototype.$DbStorage.getItem("rocketfuel_access");
  const refresh = app.prototype.$DbStorage.getItem("rocketfuel_refresh");
  const status = app.prototype.$DbStorage.getItem("rocketfuel_status");

  store.commit("auth/setOldTokens", { access, refresh, status });

  if (!to.meta.middleware) {
    return next();
  }
  const { middleware } = to.meta;
  const context = {
    to,
    from,
    next,
    store,
  };
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});

export default router;
